import { Request } from '~src/httpClient/serverApi/requests/Request';
import {IResult} from '~src/httpClient/serverApi/types/IResponse';

export interface IGetSiteEncryptionKeyParams {}

export interface IGetSiteEncryptionKeyResult extends IResult {
  keyId?: string;
  keyVersionId?: string;
  keyCreatedDate?: string;
  keyRotatedDate?: string;
}

export class GetSiteEncryptionKeyRequest extends Request<IGetSiteEncryptionKeyParams, IGetSiteEncryptionKeyResult> {
  constructor(params: IGetSiteEncryptionKeyParams) {
    super('getSiteEncryptionKey', params);
  }
}